import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
/**
 * /cartotheque/:id/description - what a cartothèque card's printed QR code
 * links to (see CardPdfBuilder's own card_show_qr_code handling). Reads
 * straight off ShowCartothequeEntryDescriptionController's own plain JSON
 * endpoint via app.request(), not app.store - that endpoint is
 * deliberately not a JSON:API resource (see that controller's own
 * docblock for why CartothequeEntryResource itself isn't reused here), so
 * there's no Model to go through.
 *
 * Public on purpose, confirmed directly with the société admin who
 * requested this feature ("cette description sera accessible pour
 * quiconque scanne le qrcode, sans connexion") - unlike every other page
 * in this extension, this one never checks app.session.user or calls
 * promptLogin(). A logged-in visitor still sees identical content to a
 * guest, but the surrounding site chrome (nav/menu, ChampisBanner,
 * ChampisFooter) is deliberately stripped for everyone via the
 * body.ChampisNoChrome toggle below (see forum.less's own rule) -
 * requested directly, since whoever scans a printed card's QR code lands
 * here with no other reason to be on the site at all.
 */
export default class CartothequeEntryDescriptionPage extends Page {
  data = null;
  notFound = false;
  loadedId = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.notFound = false;
    this.load(m.route.param('id'));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    document.body.classList.add('ChampisNoChrome');
  }
  onremove(vnode) {
    super.onremove(vnode);
    document.body.classList.remove('ChampisNoChrome');
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    if (String(this.loadedId) !== m.route.param('id')) {
      this.load(m.route.param('id'));
    }
  }
  load(id) {
    this.loadedId = id;
    this.data = null;
    this.notFound = false;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/champis-exhibitions-cartotheque-entries/' + id + '/description'
    }).then(response => {
      this.data = response;
      app.setTitle(response.canonicalName || response.scientificName || response.vernacularName || '');
      m.redraw();
    }).catch(() => {
      this.notFound = true;
      m.redraw();
    });
  }
  view() {
    const t = function (key, params) {
      if (params === void 0) {
        params = {};
      }
      return app.translator.trans(`champis-exhibitions.forum.cartotheque_entry_description_page.${key}`, params);
    };
    const data = this.data;
    return m("div", {
      className: "Page ChampisCartothequeEntryDescriptionPage"
    }, m("div", {
      className: "container"
    }, this.notFound ? m("p", {
      className: "ChampisCartothequeEntryDescriptionPage-error"
    }, t('not_found')) : !data ? m(LoadingIndicator, null) : m("div", {
      className: "Page-content"
    }, m("header", {
      className: "ChampisCartothequeEntryDescriptionPage-header"
    }, m("h1", null, data.canonicalName || data.scientificName, data.author && m("span", {
      className: "ChampisCartothequeEntryDescriptionPage-author"
    }, " ", data.author)), data.vernacularName && m("p", {
      className: "ChampisCartothequeEntryDescriptionPage-vernacularName"
    }, data.vernacularName), m("p", {
      className: "ChampisCartothequeEntryDescriptionPage-meta"
    }, data.phylum && m("span", null, data.phylum), data.family && m("span", null, data.family), data.no && m("span", null, t('card_no', {
      no: data.no
    })), data.societyName && m("span", null, data.societyName))), m("div", {
      className: "ChampisCartothequeEntryDescriptionPage-body Post-body"
    }, m.trust(data.description)))));
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/CartothequeEntryDescriptionPage', CartothequeEntryDescriptionPage);